module.exports = __webpack_public_path__ + "img/logo.c8a1ff6f.png";